export default __webpack_public_path__ + "static/media/Group 23364.604e48dc.svg";